import { useState } from "react";
import { generateView } from "./Print";
import {
  IGeneratePDF_RESMI,
  IGeneratePDF_SIMPEL,
  IGeneratePDF_SURAT_JALAN,
  IGeneratePDF_TIKET,
} from "./generateInvoice.type";

const useGenerateInvoice = () => {
  const [loading, setIsLoading] = useState(false);

  const generateResmi = async (data: IGeneratePDF_RESMI) => {
    setIsLoading(true);
    await generateView(data, "Resmi", "Resmi");
    setIsLoading(false);
  };

  const generateTiket = (data: IGeneratePDF_TIKET) => {
    setIsLoading(true);
    generateView(data, "Tiket", "Tiket");
    setIsLoading(false);
  };

  const generateSuratJalan = async (data: IGeneratePDF_SURAT_JALAN) => {
    setIsLoading(true);
    await generateView(data, "Surat Jalan", "SuratJalan");
    setIsLoading(false);
  };

  const generateSimpel = (data: IGeneratePDF_SIMPEL) => {
    setIsLoading(true);
    generateView(data, "Simpel", "Simpel");
    setIsLoading(false);
  };

  return {
    loading,
    generateResmi,
    generateTiket,
    generateSuratJalan,
    generateSimpel,
  };
};

export default useGenerateInvoice;
